import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ROUTES } from "src/app/utils/routes";
import { UserDataService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private userService: UserDataService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.userService.user$.pipe(
      map((user) => {
        if (user) {
          return true;
        } else {
          this.router.navigate([ROUTES.LOGIN_PAGE]);
          return false;
        }
      })
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class NoAuthGuard implements CanActivate {
  constructor(private userService: UserDataService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.userService.user$.pipe(
      map((user) => {
        if (!user) {
          return true;
        } else {
          if (this.userService.defaultPage) {
            this.router.navigateByUrl(this.userService.defaultPage);
          } else {
            this.router.navigateByUrl(ROUTES.HELP_PAGE);
          }
          return false;
        }
      })
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class IsMultiTenant implements CanActivate {
  constructor(private userService: UserDataService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.userService.allTenants$.pipe(
      map((tenants) => {
        if (
          tenants &&
          tenants.tenantProfiles &&
          tenants.tenantProfiles.length
        ) {
          return true;
        } else {
          this.router.navigateByUrl(ROUTES.LOGIN_PAGE);
          return false;
        }
      })
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class IsMultiTenantNot implements CanActivate {
  constructor(private userService: UserDataService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.userService.allTenants$.pipe(
      map((tenants) => {
        if (!tenants) {
          return true;
        } else {
          this.router.navigateByUrl(ROUTES.MULTITENANT_ACCESS_PAGE);
          return false;
        }
      })
    );
  }
}
